export const isEmpty = (str) => {
    if (str === null || str === undefined)
        return true;
    return !str.trim();
    ;
};
export const truncate = (str, nbOfChars) => {
    // Handle null/undefined input first
    if (str === null || str === undefined) {
        return str; // Return null or undefined as received
    }
    // Handle empty string or string not needing truncation
    if (str.length <= nbOfChars)
        return str;
    // Perform truncation
    else
        return str.substring(0, nbOfChars) + "...";
};
